import axios from 'axios';

export const warehouseApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/warehouse`,
    headers: {
        'Content-Type': 'application/json'
    }
})